export const SCHEDULE_FILTER_KEY = {
  ACTIVE_CLASSES: 'ACTIVE_CLASSES',
  DISABLED_CLASSES: 'DISABLED_CLASSES',
  WITH_CLIENTS_WAITING: 'WITH_CLIENTS_WAITING',
  WITH_NEW_CLIENTS: 'WITH_NEW_CLIENTS',
  WITH_RESERVATIONS: 'WITH_RESERVATIONS',
};

export const SCHEDULE_FILTER_COUNT_ZERO = 0;

export const SCHEDULE_FILTER_WITH_NEW_CLIENTS_VISIBLE = false;
